<ion-modal [isOpen]="isOpen" (didDismiss)="onClose()" class="card-popup">
  <ng-template>
    <ion-header>
      <ion-toolbar>
  <ion-title>Preview Log Entry</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="onClose()">
            <ion-icon name="close"></ion-icon>
            Close
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="preview-content">
        <!-- Log Details Section -->
        <div class="preview-section">
          <div class="section-header">
            <ion-text color="medium">
              <h2>Log Details</h2>
            </ion-text>
          </div>
          <div class="section-content" *ngIf="logRowData">
            <div *ngFor="let field of logDisplayFields" class="detail-row">
              <ion-text color="medium" class="label">{{field.label}}:</ion-text>
              <ion-text class="value">{{field.value}}</ion-text>
            </div>
          </div>
        </div>

        <!-- Photo Grid Viewer Section -->
        <div class="preview-section">
          <div class="section-header">
            <ion-text color="medium">
              <h2>Log Photos</h2>
            </ion-text>
          </div>
          <div class="section-content">
            <app-photo-grid-viewer
              *ngIf="!photosDisabled"
              [photos]="logEntryPhotos"
              [photosEditable]="false"
             ></app-photo-grid-viewer>
            
            <ion-text color="medium" *ngIf="photosDisabled">
              <p>No photos will be sent with this log entry</p>
            </ion-text>
          </div>
        </div>

        <!-- Email Preview Section -->
        <div class="preview-section">
          <div class="section-header">
            <ion-text color="medium">
              <h2>Notification Email</h2>
            </ion-text>
          </div>
          <div class="section-content">
            <div class="toggle-row">
              <ion-toggle
                [(ngModel)]="emailsDisabled"
                (ionChange)="onToggleEmailsDisabled($event)">
              </ion-toggle>
              <ion-text color="medium">
                <p>Disable Emails</p>
              </ion-text>
            </div>

            <div class="email-preview">
              <app-preview-email
                *ngIf="!emailsDisabled"
                [includePhotosInEmail]="includePhotosInEmail"
                (togglePhotosInEmail)="onTogglePhotosInEmail($event)">
              </app-preview-email>

              <ion-text color="medium" *ngIf="emailsDisabled">
                <p>No email will be sent with this log entry</p>
              </ion-text>
            </div>
          </div>
        </div>
      </div>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-button
          (click)="onSubmit()"
          [disabled]="isLoading"
          expand="full"
          class="submit-button">
          <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
          <ng-container *ngIf="!isLoading">
            <ion-icon name="checkmark" slot="start"></ion-icon>
            <ion-label>Submit Log Entry</ion-label>
          </ng-container>
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal> 